import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';

const t = withLocalePrefix('talent_matching.bulk_actions.feedback');

type Props = {
  openModal: () => void;
  selectionsHelper: SelectionsHelper;
  loading: boolean;
};

const FeedbackButton = ({ openModal, selectionsHelper, loading }: Props) => {
  const isDisabled = selectionsHelper.noneSelected;

  return isDisabled ? (
    <Tooltip
      label={t('tooltip.none_selected')}
      ariaLabel={t('tooltip.none_selected')}
    >
      <SecondaryButton onClick={openModal} disabled={true} size="md">
        {t('button', { count: selectionsHelper.totalSelected })}
      </SecondaryButton>
    </Tooltip>
  ) : (
    <SecondaryButton
      onClick={openModal}
      loading={loading}
      disabled={loading}
      size="md"
    >
      {t('button', { count: selectionsHelper.totalSelected })}
    </SecondaryButton>
  );
};

export default FeedbackButton;
